import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  SHOW_ERROR_NOTIFICATION,
  ADD_ERROR,
  IS_LOADING,
  SET_LOADING_TEXT,
  AppActionTypes,
  AppState,
} from '../types';

export const initialState: AppState = {
  notifications: {
    queue: [],
  },
  supportedLanguages: [
    { value: 'de', displayValue: 'Deutsch' },
    { value: 'en', displayValue: 'English' },
  ],
  help: {
    show: false,
    id: '',
  },
  isLoading: false,
  loadingText: undefined,
};

export default (state = initialState, action: AppActionTypes): AppState => {
  switch (action.type) {
    case ADD_ERROR:
      return {
        ...state,
        notifications: {
          lastIndex: state.notifications.lastIndex,
          queue: state.notifications.queue.concat({
            text: action.error,
            type: 'error',
          }),
        },
      };
    case 'SHOW_HELP':
      return {
        ...state,
        help: {
          show: true,
          id: action.helpId,
        },
      };
    case 'HIDE_HELP':
      return {
        ...state,
        help: {
          show: false,
          id: '',
        },
      };
    case SHOW_NOTIFICATION:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          queue: [{
            text: action.message,
            type: 'notification',
          }],
        },
      };
    case SHOW_ERROR_NOTIFICATION:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          queue: [{
            text: action.message,
            type: 'error',
          }],
        },
      };
    case HIDE_NOTIFICATION:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          queue: [],
        },
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        loadingText: !action.isLoading ? undefined : state.loadingText,
      };
    case SET_LOADING_TEXT:
      return {
        ...state,
        loadingText: action.payload,
      };
    default:
      return state;
  }
};
